export default __webpack_public_path__ + "static/media/banner-7.1e471211.jpg";